// Do not modify! Autogenerated from gen_localization.js
export const LOCALIZATION_PREFIX = '@';
const T = {
  admin: {
    alarms: {
      deleteFailed: '@admin.alarms.deleteFailed',
      limitToAssets: '@admin.alarms.limitToAssets',
      rule: {
        operator: '@admin.alarms.rule.operator',
        value: '@admin.alarms.rule.value',
        variable: '@admin.alarms.rule.variable'
      },
      saveFailed: '@admin.alarms.saveFailed'
    },
    alert: {
      delete: {
        failed: {
          rootpermission: '@admin.alert.delete.failed.rootpermission'
        },
        successful: {
          rootpermission: '@admin.alert.delete.successful.rootpermission'
        }
      }
    },
    asset: {
      delete: {
        deviceLabel: '@admin.asset.delete.deviceLabel',
        deviceWarning: '@admin.asset.delete.deviceWarning'
      }
    },
    assetInfo: {
      name: {
        placeholder: '@admin.assetInfo.name.placeholder'
      },
      parent: {
        placeholder: '@admin.assetInfo.parent.placeholder'
      }
    },
    assets: {
      update: {
        model_failed: '@admin.assets.update.model_failed',
        model: '@admin.assets.update.model'
      }
    },
    assetwizard: {
      review: '@admin.assetwizard.review'
    },
    claims: {
      isDeveloper: '@admin.claims.isDeveloper',
      title: '@admin.claims.title',
      update: {
        error: '@admin.claims.update.error',
        success: '@admin.claims.update.success'
      }
    },
    common: {
      publish_replace: '@admin.common.publish_replace',
      publish: '@admin.common.publish'
    },
    createAsset: {
      name: {
        placeholder: '@admin.createAsset.name.placeholder'
      },
      selectBinding: '@admin.createAsset.selectBinding',
      selectSource: '@admin.createAsset.selectSource',
      title: '@admin.createAsset.title'
    },
    createTree: {
      title: '@admin.createTree.title'
    },
    createuser: {
      error: '@admin.createuser.error',
      success: '@admin.createuser.success',
      title: '@admin.createuser.title'
    },
    dashboard: {
      shownonhome: '@admin.dashboard.shownonhome',
      notshownonhome: '@admin.dashboard.notshownonhome',
      selectdashboards: '@admin.dashboard.selectdashboards',
      homedashboards: '@admin.dashboard.homedashboards'
    },
    deleteuser: {
      error: '@admin.deleteuser.error',
      success: '@admin.deleteuser.success'
    },
    edituser: {
      title: '@admin.edituser.title'
    },
    graphTree: {
      addEdge: {
        error: '@admin.graphTree.addEdge.error',
        success: '@admin.graphTree.addEdge.success'
      },
      addNode: {
        error: '@admin.graphTree.addNode.error'
      },
      deleteEdge: {
        error: '@admin.graphTree.deleteEdge.error',
        success: '@admin.graphTree.deleteEdge.success'
      },
      deleteNode: {
        error: '@admin.graphTree.deleteNode.error',
        success: '@admin.graphTree.deleteNode.success'
      },
      informationTab: {
        activeItem: '@admin.graphTree.informationTab.activeItem',
        saveButton: '@admin.graphTree.informationTab.saveButton'
      },
      newAsset: '@admin.graphTree.newAsset',
      newTree: '@admin.graphTree.newTree',
      pruneAssetDependents: '@admin.graphTree.pruneAssetDependents',
      tab: {
        access: '@admin.graphTree.tab.access',
        dashboard: '@admin.graphTree.tab.dashboard',
        information: '@admin.graphTree.tab.information',
        link: '@admin.graphTree.tab.link',
        treeProperties: '@admin.graphTree.tab.treeProperties'
      },
      updateNode: {
        error: '@admin.graphTree.updateNode.error',
        success: '@admin.graphTree.updateNode.success'
      }
    },
    groups: {
      create: {
        title: '@admin.groups.create.title'
      },
      edit: {
        title: '@admin.groups.edit.title'
      }
    },
    model: {
      list: {
        error: '@admin.model.list.error'
      }
    },
    notifications: {
      broadcast: '@admin.notifications.broadcast',
      channels: '@admin.notifications.channels',
      defaultUsers: '@admin.notifications.defaultUsers',
      defaultGroups: '@admin.notifications.defaultGroups',
      alarmTriggers: '@admin.notifications.alarmTriggers'
    },
    saveuser: {
      error: '@admin.saveuser.error',
      success: '@admin.saveuser.success'
    },
    tabs: {
      assetTrees: '@admin.tabs.assetTrees',
      groups: '@admin.tabs.groups',
      organizations: '@admin.tabs.organizations',
      users: '@admin.tabs.users'
    },
    trees: {
      createTree: {
        placeholder: '@admin.trees.createTree.placeholder'
      },
      error: {
        failedload: '@admin.trees.error.failedload'
      }
    },
    user: {
      list: {
        error: '@admin.user.list.error'
      }
    },
    users: {
      column: {
        login: '@admin.users.column.login'
      },
      createuser: {
        forcepasswordchange: '@admin.users.createuser.forcepasswordchange'
      }
    }
  },
  alarm: {
    acknowledge: '@alarm.acknowledge',
    acknowledged: '@alarm.acknowledged',
    activeAlarms: '@alarm.activeAlarms',
    association: {
      header: '@alarm.association.header'
    },
    firstTriggered: '@alarm.firstTriggered',
    inactiveAlarms: '@alarm.inactiveAlarms',
    lastTriggered: '@alarm.lastTriggered',
    noAlarms: '@alarm.noAlarms',
    status: {
      tooltip: {
        active: '@alarm.status.tooltip.active',
        inactive: '@alarm.status.tooltip.inactive'
      }
    },
    unacknowledged: '@alarm.unacknowledged'
  },
  asset: {
    authentication: {
      type: '@asset.authentication.type'
    },
    connectionStatus: '@asset.connectionStatus',
    connectionStatusUpdate: '@asset.connectionStatusUpdate',
    create: {
      linkExisting: '@asset.create.linkExisting',
      usePhysical: '@asset.create.usePhysical'
    },
    createText: '@asset.createText',
    deletePhysicalQuestion: '@asset.deletePhysicalQuestion',
    deleteQuestion: '@asset.deleteQuestion',
    dependencies: '@asset.dependencies',
    details: '@asset.details',
    idFormat: {
      invalid: '@asset.idFormat.invalid'
    },
    lastActive: '@asset.lastActive',
    physical: '@asset.physical',
    property: {
      desired: '@asset.property.desired',
      reported: '@asset.property.reported'
    },
    provider: {
      template: '@asset.provider.template'
    },
    updateDesiredError: '@asset.updateDesiredError',
    updateDesiredSuccess: '@asset.updateDesiredSuccess'
  },
  colorPicker: {
    addCustomColor: '@colorPicker.addCustomColor',
    customColor: '@colorPicker.customColor',
    defaultColors: '@colorPicker.defaultColors',
    defaultColor: '@colorPicker.defaultColor',
    color: '@colorPicker.color'
  },
  common: {
    actions: '@common.actions',
    add: '@common.add',
    added: {
      permission: {
        error: '@common.added.permission.error',
        success: '@common.added.permission.success'
      }
    },
    aggregations: {
      avg: '@common.aggregations.avg',
      first: '@common.aggregations.first',
      last: '@common.aggregations.last',
      max: '@common.aggregations.max',
      median: '@common.aggregations.median',
      min: '@common.aggregations.min',
      sum: '@common.aggregations.sum'
    },
    alarm: '@common.alarm',
    alarms: '@common.alarms',
    apiToken: '@common.apiToken',
    apply: '@common.apply',
    asset: '@common.asset',
    assetId: '@common.assetId',
    assets: '@common.assets',
    authentication: {
      error: '@common.authentication.error',
      inProgress: '@common.authentication.inProgress'
    },
    bindings: '@common.bindings',
    cancel: '@common.cancel',
    children: '@common.children',
    clearselection: '@common.clearselection',
    close: '@common.close',
    color: '@common.color',
    commands: '@common.commands',
    componentName: '@common.componentName',
    confirmDeletion: '@common.confirmDeletion',
    coordinates: '@common.coordinates',
    copied: '@common.copied',
    copy: '@common.copy',
    create: '@common.create',
    dataProvider: '@common.dataProvider',
    dataSource: '@common.dataSource',
    dayunits: {
      today: '@common.dayunits.today',
      yesterday: '@common.dayunits.yesterday'
    },
    delete: '@common.delete',
    description: '@common.description',
    noDescription: '@common.noDescription',
    displayname: '@common.displayname',
    details: '@common.details',
    draft: '@common.draft',
    edit: '@common.edit',
    email: '@common.email',
    error: {
      failed: {
        loading: {
          list: '@common.error.failed.loading.list',
          assets: '@common.error.failed.loading.assets'
        }
      },
      generic: '@common.error.generic'
    },
    errorUpdatingData: '@common.errorUpdatingData',
    enable: '@common.enable',
    enabled: '@common.enabled',
    from: '@common.from',
    groupBy: {
      asset: '@common.groupBy.asset',
      label: '@common.groupBy.label',
      signal: '@common.groupBy.signal'
    },
    groups: '@common.groups',
    id: '@common.id',
    idExists: '@common.idExists',
    input: {
      aggregate: {
        title: '@common.input.aggregate.title'
      },
      models: {
        title: '@common.input.models.title'
      },
      nodes: {
        relativenode: '@common.input.nodes.relativenode',
        selectmultiple: '@common.input.nodes.selectmultiple',
        selectsingle: '@common.input.nodes.selectsingle',
        title: '@common.input.nodes.title',
        twoormoreselected: '@common.input.nodes.twoormoreselected'
      },
      text: {
        title: '@common.input.text.title'
      },
      timebucket: {
        title: '@common.input.timebucket.title'
      },
      timerange: {
        title: '@common.input.timerange.title'
      }
    },
    signals: '@common.signals',
    successfullyUpdated: '@common.successfullyUpdated',
    notificationSubscribers: '@common.notificationSubscribers',
    onesignal: '@common.onesignal',
    twosignals: '@common.twosignals',
    invalidValueFormat: '@common.invalidValueFormat',
    iothubDevice: '@common.iothubDevice',
    language: '@common.language',
    last: '@common.last',
    lastActive: '@common.lastActive',
    latitude: '@common.latitude',
    lineStyle: '@common.lineStyle',
    link: '@common.link',
    list: {
      clearFilters: '@common.list.clearFilters',
      clearFiltersAction: '@common.list.clearFiltersAction',
      empty: '@common.list.empty',
      emptyFormatted: '@common.list.emptyFormatted',
      pagination: {
        currPageAriaLabel: '@common.list.pagination.currPageAriaLabel',
        items: '@common.list.pagination.items',
        itemsPerPage: '@common.list.pagination.itemsPerPage',
        ofWord: '@common.list.pagination.ofWord',
        optionsToggleAriaLabel: '@common.list.pagination.optionsToggleAriaLabel',
        page: '@common.list.pagination.page',
        pages: '@common.list.pagination.pages',
        paginationAriaLabel: '@common.list.pagination.paginationAriaLabel',
        perPageSuffix: '@common.list.pagination.perPageSuffix',
        toFirstPageAriaLabel: '@common.list.pagination.toFirstPageAriaLabel',
        toLastPageAriaLabel: '@common.list.pagination.toLastPageAriaLabel',
        toNextPageAriaLabel: '@common.list.pagination.toNextPageAriaLabel',
        toPreviousPageAriaLabel: '@common.list.pagination.toPreviousPageAriaLabel'
      }
    },
    licenseAgreement: '@common.licenseAgreement',
    licenseAgreementAccept: '@common.licenseAgreementAccept',
    loading: '@common.loading',
    login: '@common.login',
    loginId: '@common.loginId',
    logout: '@common.logout',
    longitude: '@common.longitude',
    max: '@common.max',
    manage: '@common.manage',
    metaProperties: '@common.metaProperties',
    migrate: '@common.migrate',
    min: '@common.min',
    model: '@common.model',
    modelId: '@common.modelId',
    modelName: '@common.modelName',
    modeltype: '@common.modeltype',
    name: '@common.name',
    never: '@common.never',
    next: '@common.next',
    no: '@common.no',
    noDashboardsDescription: '@common.noDashboardsDescription',
    noDashboardsTitle: '@common.noDashboardsTitle',
    noDataSource: '@common.noDataSource',
    noname: '@common.noname',
    ok: '@common.ok',
    parent: '@common.parent',
    password: '@common.password',
    physicalId: '@common.physicalId',
    plotlines: '@common.plotlines',
    primaryConnectionString: '@common.primaryConnectionString',
    properties: '@common.properties',
    propertyValue: '@common.propertyValue',
    logicalOperator: {
      and: '@common.logicalOperator.and',
      or: '@common.logicalOperator.or'
    },
    logicalOperatorTitle: '@common.logicalOperatorTitle',
    providers: '@common.providers',
    provisionData: '@common.provisionData',
    published: {
      model_failed: '@common.published.model_failed',
      model: '@common.published.model'
    },
    readonly: '@common.readonly',
    refresh: '@common.refresh',
    refreshInterval: '@common.refreshInterval',
    relativeTo: '@common.relativeTo',
    removed: {
      permission: {
        error: '@common.removed.permission.error',
        success: '@common.removed.permission.success'
      }
    },
    request: {
      delete: {
        failed: '@common.request.delete.failed',
        success: '@common.request.delete.success'
      }
    },
    required: '@common.required',
    relation: '@common.relation',
    relations: '@common.relations',
    save_model_failed: '@common.save_model_failed',
    save_model: '@common.save_model',
    save: '@common.save',
    secondaryConnectionString: '@common.secondaryConnectionString',
    select: '@common.select',
    selectgroups: '@common.selectgroups',
    selectRelativeTime: '@common.selectRelativeTime',
    sms: '@common.sms',
    sortBy: {
      ascending: '@common.sortBy.ascending',
      descending: '@common.sortBy.descending',
      label: '@common.sortBy.label'
    },
    staticValue: '@common.staticValue',
    status: '@common.status',
    subject: '@common.subject',
    telemetry: '@common.telemetry',
    template: '@common.template',
    templates: '@common.templates',
    timebuckets: {
      p1d: '@common.timebuckets.p1d',
      p1m: '@common.timebuckets.p1m',
      pt12h: '@common.timebuckets.pt12h',
      pt15m: '@common.timebuckets.pt15m',
      pt1h: '@common.timebuckets.pt1h',
      pt1m: '@common.timebuckets.pt1m',
      pt5m: '@common.timebuckets.pt5m',
      raw: '@common.timebuckets.raw'
    },
    timeoffsets: {
      custom: '@common.timeoffsets.custom',
      t12hours: '@common.timeoffsets.t12hours',
      t1hour: '@common.timeoffsets.t1hour',
      t1year: '@common.timeoffsets.t1year',
      t24hours: '@common.timeoffsets.t24hours',
      t30days: '@common.timeoffsets.t30days',
      t30min: '@common.timeoffsets.t30min',
      t6hours: '@common.timeoffsets.t6hours',
      t7days: '@common.timeoffsets.t7days',
      t90days: '@common.timeoffsets.t90days'
    },
    timestamp: '@common.timestamp',
    timeunits: {
      days: '@common.timeunits.days',
      hours: '@common.timeunits.hours',
      minutes: '@common.timeunits.minutes',
      months: '@common.timeunits.months',
      weeks: '@common.timeunits.weeks',
      years: '@common.timeunits.years'
    },
    to: '@common.to',
    togglefullscreen: '@common.togglefullscreen',
    type: '@common.type',
    unlink: '@common.unlink',
    update: '@common.update',
    userId: '@common.userId',
    value: '@common.value',
    width: '@common.width',
    yes: '@common.yes',
    organization: '@common.organization',
    selectorganization: '@common.selectorganization',
    propertiesconditions: '@common.propertiesconditions'
  },
  component: {
    treeSelection: {
      allowedSelection: '@component.treeSelection.allowedSelection',
      assets: '@component.treeSelection.assets',
      both: '@component.treeSelection.both',
      nodes: '@component.treeSelection.nodes'
    }
  },
  dashboards: {
    failedtoload: '@dashboards.failedtoload'
  },
  dashboard: {
    usingdynamicassets: '@dashboard.usingdynamicassets',
    editor: {
      inputs: {
        help: {
          placeholder: '@dashboard.editor.inputs.help.placeholder',
          title: '@dashboard.editor.inputs.help.title'
        },
        json: {
          options: '@dashboard.editor.inputs.json.options'
        },
        title: {
          placeholder: '@dashboard.editor.inputs.title.placeholder',
          title: '@dashboard.editor.inputs.title.title'
        },
        showpath: '@dashboard.editor.inputs.showpath',
        visibilityconditions: {
          title: '@dashboard.editor.inputs.visibilityconditions.title'
        }
      },
      modal: {
        editpanel: '@dashboard.editor.modal.editpanel'
      },
      paneltypes: {
        title: '@dashboard.editor.paneltypes.title'
      }
    },
    panel: {
      unknownType: '@dashboard.panel.unknownType'
    },
    panels: {
      dataSource: {
        lastValue: '@dashboard.panels.dataSource.lastValue',
        realTime: '@dashboard.panels.dataSource.realTime',
        signals: '@dashboard.panels.dataSource.signals'
      },
      types: {
        activealarms: '@dashboard.panels.types.activealarms',
        chart: '@dashboard.panels.types.chart',
        dial: '@dashboard.panels.types.dial',
        lastValueDialList: '@dashboard.panels.types.lastValueDialList',
        map: '@dashboard.panels.types.map',
        realtimeDialList: '@dashboard.panels.types.realtimeDialList',
        signalinfo: '@dashboard.panels.types.signalinfo',
        telemetryCard: '@dashboard.panels.types.telemetryCard',
        text: '@dashboard.panels.types.text',
        assetList: '@dashboard.panels.types.assetList'
      }
    }
  },
  dashboardspage: {
    createdashboard: '@dashboardspage.createdashboard',
    editor: {
      error: {
        failedload: '@dashboardspage.editor.error.failedload',
        saveddashboard: '@dashboardspage.editor.error.saveddashboard'
      },
      modified: '@dashboardspage.editor.modified',
      newdashboard: '@dashboardspage.editor.newdashboard',
      success: {
        saveddashboard: '@dashboardspage.editor.success.saveddashboard'
      }
    },
    error: {
      failedload: '@dashboardspage.error.failedload'
    },
    title: '@dashboardspage.title'
  },
  graph: {
    dateTime: '@graph.dateTime',
    line: {
      chart: {
        view: '@graph.line.chart.view'
      }
    },
    table: {
      view: '@graph.table.view'
    },
    toolbar: {
      selectSignals: '@graph.toolbar.selectSignals',
      time_aggregate: '@graph.toolbar.time_aggregate',
      timepicker: {
        relative: {
          checkbox: '@graph.toolbar.timepicker.relative.checkbox',
          placeholder: '@graph.toolbar.timepicker.relative.placeholder'
        }
      },
      timespan: '@graph.toolbar.timespan'
    }
  },
  map: {
    controls: {
      showmaptypeselector: '@map.controls.showmaptypeselector',
      showzoomcontrols: '@map.controls.showzoomcontrols'
    }
  },
  migrate: {
    asset: '@migrate.asset',
    assets: '@migrate.assets',
    binding: {
      target: '@migrate.binding.target'
    },
    error: '@migrate.error',
    success: '@migrate.success'
  },
  modals: {
    confirm: {
      publish: {
        content_replace: '@modals.confirm.publish.content_replace',
        content: '@modals.confirm.publish.content',
        title: '@modals.confirm.publish.title'
      }
    },
    confirmdelete: {
      content: '@modals.confirmdelete.content',
      title: '@modals.confirmdelete.title',
      titleError: '@modals.confirmdelete.titleError',
      tooManyAssets: '@modals.confirmdelete.tooManyAssets'
    },
    selectproperties: {
      title: '@modals.selectproperties.title'
    },
    selectsignals: {
      clearFilter: '@modals.selectsignals.clearFilter',
      title: '@modals.selectsignals.title'
    }
  },
  model: {
    binding: {
      assetModel: '@model.binding.assetModel',
      select_sources: '@model.binding.select_sources',
      source: '@model.binding.source',
      sourceModel: '@model.binding.sourceModel',
      sources: '@model.binding.sources',
      target: '@model.binding.target',
      transform: '@model.binding.transform'
    },
    bindingwarning: '@model.bindingwarning',
    command: {
      request: {
        payload: '@model.command.request.payload'
      },
      response: {
        payload: '@model.command.response.payload'
      }
    },
    comment: '@model.comment',
    coordinate: {
      inputtype: '@model.coordinate.inputtype'
    },
    description: '@model.description',
    displayName: '@model.displayName',
    export: '@model.export',
    id: '@model.id',
    import: {
      idExists: '@model.import.idExists'
    },
    list: {
      edit: {
        version: '@model.list.edit.version'
      },
      import: {
        asset: '@model.list.import.asset'
      },
      new: {
        asset: '@model.list.new.asset',
        component: '@model.list.new.component',
        provider: '@model.list.new.provider',
        version: '@model.list.new.version'
      }
    },
    minorVersion: '@model.minorVersion',
    name: '@model.name',
    schema: '@model.schema',
    semanticType: '@model.semanticType',
    tab: {
      commands: '@model.tab.commands',
      components: '@model.tab.components',
      defaultData: '@model.tab.defaultData',
      manifest: '@model.tab.manifest',
      properties: '@model.tab.properties',
      schema: '@model.tab.schema',
      telemetry: '@model.tab.telemetry'
    },
    type: '@model.type',
    unit: '@model.unit',
    upload: {
      json: {
        title: '@model.upload.json.title'
      }
    },
    version: '@model.version',
    writable: '@model.writable'
  },
  modelContentSelector: {
    emptyProperties: '@modelContentSelector.emptyProperties',
    emptyPropertiesSelection: '@modelContentSelector.emptyPropertiesSelection',
    emptySelection: '@modelContentSelector.emptySelection',
    emptySignals: '@modelContentSelector.emptySignals'
  },
  organization: {
    create: {
      title: '@organization.create.title'
    },
    group: {
      create: {
        title: '@organization.group.create.title'
      }
    }
  },
  paging: {
    infoText: '@paging.infoText'
  },
  privileges: {
    asset_management: '@privileges.asset_management',
    dashboard_management: '@privileges.dashboard_management',
    user_management: '@privileges.user_management',
    tree_management: '@privileges.tree_management',
    model_management: '@privileges.model_management',
    alarm_management: '@privileges.alarm_management',
    org_management: '@privileges.org_management',
    provider_management: '@privileges.provider_management',
    provider_client_management: '@privileges.provider_client_management',
    template_management: '@privileges.template_management',
    workflow_management: '@privileges.workflow_management',
    notification_management: '@privileges.notification_management',
    device_management: '@privileges.device_management'
  },
  permissions: {
    owner: '@permissions.owner',
    manager: '@permissions.manager',
    member: '@permissions.member',
    manageTenants: '@permissions.manageTenants',
    manageUsers: '@permissions.manageUsers',
    manageGroups: '@permissions.manageGroups',
    manageDashboards: '@permissions.manageDashboards',
    manageAssets: '@permissions.manageAssets',
    manageTrees: '@permissions.manageTrees',
    manageModels: '@permissions.manageModels',
    manageProviders: '@permissions.manageProviders',
    manageProviderClients: '@permissions.manageProviderClients',
    manageTemplates: '@permissions.manageTemplates',
    manageWorkflows: '@permissions.manageWorkflows',
    manageNotifications: '@permissions.manageNotifications',
    manageAlarms: '@permissions.manageAlarms',
    manageOrganizations: '@permissions.manageOrganizations',
    manageDevices: '@permissions.manageDevices',
    relations: {
      user: '@permissions.relations.user',
      group: '@permissions.relations.group',
      dashboard: '@permissions.relations.dashboard',
      tree: '@permissions.relations.tree',
      asset: '@permissions.relations.asset',
      model: '@permissions.relations.model',
      provider: '@permissions.relations.provider',
      providerClient: '@permissions.relations.providerClient',
      template: '@permissions.relations.template',
      workflow: '@permissions.relations.workflow',
      notification: '@permissions.relations.notification',
      alarm: '@permissions.relations.alarm',
      organization: '@permissions.relations.organization',
      device: '@permissions.relations.device'
    }
  },
  provisioningCard: {
    showSignals: '@provisioningCard.showSignals'
  },
  sidebar: {
    item: {
      admin: '@sidebar.item.admin',
      alarms: '@sidebar.item.alarms',
      analytics: '@sidebar.item.analytics',
      assets: '@sidebar.item.assets',
      bindings: '@sidebar.item.bindings',
      charts: '@sidebar.item.charts',
      dashboards: '@sidebar.item.dashboards',
      groups: '@sidebar.item.groups',
      home: '@sidebar.item.home',
      models: '@sidebar.item.models',
      organizations: '@sidebar.item.organizations',
      providers: '@sidebar.item.providers',
      providerClients: '@sidebar.item.providerClients',
      provisionTemplates: '@sidebar.item.provisionTemplates',
      roles: '@sidebar.item.roles',
      trees: '@sidebar.item.trees',
      users: '@sidebar.item.users',
      nodes: '@sidebar.item.nodes',
      workflows: '@sidebar.item.workflows',
      notifications: '@sidebar.item.notifications'
    }
  },
  signals: {
    removeAll: '@signals.removeAll'
  },
  tag: {
    edit: '@tag.edit',
    name_placeholder: '@tag.name_placeholder',
    name: '@tag.name',
    value_placeholder: '@tag.value_placeholder',
    value: '@tag.value'
  },
  tags: {
    add: '@tags.add',
    category: '@tags.category'
  },
  unit: {
    concentration: {
      ppm: '@unit.concentration.ppm'
    },
    length: {
      metre: '@unit.length.metre'
    },
    power: {
      kilowatt: '@unit.power.kilowatt'
    },
    pressure: {
      millibar: '@unit.pressure.millibar'
    },
    relative: {
      percentage: '@unit.relative.percentage'
    },
    temperature: {
      celsius: '@unit.temperature.celsius',
      fahrenheit: '@unit.temperature.fahrenheit'
    },
    volume: {
      cubicmetre: '@unit.volume.cubicmetre',
      litre: '@unit.volume.litre',
      litrePerSecond: '@unit.volume.litrePerSecond'
    }
  }
};
export default T;
